module.exports = __webpack_public_path__ + "static/media/CodeH.0e35307a.png";